import type { HyperHtml } from '@bayer-int/portletce-aclibv2';

import type { DataTipNavigationOption, NavigationCallbackItem } from 'portlet/models';

export function renderDataTipContent(
    html: HyperHtml,
    options: {
        title: string;
        jumpTo: DataTipNavigationOption[];
        showBy: DataTipNavigationOption[];
    },
    onClick: (action: NavigationCallbackItem) => void,
): HTMLElement {
    const { title, jumpTo, showBy } = options;

    function createButton(action: NavigationCallbackItem, label: string, icon = '') {
        return html` <div>
            <button class="list-element" onclick=${() => onClick(action)}>
                <i class="material-icons">${icon}</i>
                <span>${label}</span>
            </button>
        </div>`;
    }

    const titleHtml = title ? html`<div class="data-tip-title">${title}</div>` : '';

    const jumpToGroup = html`<div class="dropdown">
        <button class="expand list-element">
            <i class="material-icons">open_in_new</i><span>Jump to</span>
        </button>
        <div class="dropdown-content">
            ${jumpTo.map(({ action, label }) => createButton(action, label))}
        </div>
    </div>`;

    const jumpToButton = createButton(
        jumpTo[0]?.action,
        `Jump to: ${jumpTo[0]?.label}`,
        'open_in_new',
    );

    const jumpToHtml = () => {
        if (jumpTo.length > 1) return jumpToGroup;
        if (jumpTo.length === 1) return jumpToButton;
        return ``;
    };

    const showByGroup = html`<div class="dropdown">
        <button class="expand list-element">
            <i class="material-icons">filter_alt</i>
            <span>Show by</span>
        </button>
        <div class="dropdown-content">
            ${showBy.map(({ action, label }) => createButton(action, label))}
        </div>
    </div>`;

    const showByButton = createButton(
        showBy[0]?.action,
        `Show by: ${showBy[0]?.label}`,
        'filter_alt',
    );

    const showByHtml = () => {
        if (showBy.length > 1) return showByGroup;
        if (showBy.length === 1) return showByButton;
        return ``;
    };
    return html`<div>
        <div class="data-tip-content" data-testid="navigation-tooltip-options">
            ${titleHtml} ${jumpToHtml} ${showByHtml}
        </div>
        <style>
            .data-tip-content {
                margin-top: 0.5rem;
                border-top: 1px solid #ccc;
            }

            .data-tip-content .material-icons {
                font-family: 'Material Icons';
                font-size: 1rem;
                font-style: normal;
                line-height: 1rem;
                color: #595959;
                display: inline-block;
                direction: ltr;
                padding-right: 0.2em;
                -webkit-font-feature-settings: 'liga';
                -webkit-font-smoothing: antialiased;
            }

            .data-tip-content .data-tip-title {
                font-size: 1rem;
                text-align: left;
                width: 15rem;
                padding: 0.5rem;
            }

            .data-tip-content .dropdown {
                position: relative;
                display: flex;
                min-width: 15rem;
            }

            .data-tip-content .dropdown-content {
                display: none;
                position: absolute;
                width: 15rem;
                top: 0;
                right: -15rem;
                box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
                z-index: 1;
            }

            .data-tip-content .dropdown:hover .dropdown-content {
                display: block;
            }

            .data-tip-content .list-element {
                display: flex;
                font-size: 0.875rem;
                text-align: left;
                width: 100%;
                padding: 0.5rem;
                background-color: rgba(255, 255, 255, 1);
            }

            .data-tip-content .list-element:hover {
                background-color: rgba(160, 160, 160, 1);
            }

            .data-tip-content .expand > span {
                flex-grow: 1;
            }

            .data-tip-content .expand::after {
                content: '▸';
            }
        </style>
    </div> `;
}
